/**
 * <s-announcement-rotator> — rotates [data-slide] children one at a time.
 * Pauses while hovered or focused and when the tab is hidden; [data-prev]/[data-next] step manually.
 */
class SAnnouncementRotator extends HTMLElement {
  #index = 0;
  #timer = null;
  #paused = false;
  #ac;

  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    if (this.slides.length < 2) return;
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.#go(this.#index - 1, true), opts);
    this.querySelector('[data-next]')?.addEventListener('click', () => this.#go(this.#index + 1, true), opts);
    const pause = () => { this.#paused = true; this.#stop(); };
    const resume = () => { this.#paused = false; this.#start(); };
    this.addEventListener('pointerenter', pause, opts);
    this.addEventListener('pointerleave', resume, opts);
    this.addEventListener('focusin', pause, opts);
    this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) resume(); }, opts);
    document.addEventListener('visibilitychange', () => (document.hidden ? this.#stop() : this.#start()), opts);
    this.#start();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#stop();
  }

  #start() {
    this.#stop();
    if (this.#paused || document.hidden) return;
    const interval = Number(this.getAttribute('interval')) || 5000;
    this.#timer = setInterval(() => this.#go(this.#index + 1), interval);
  }

  #stop() {
    clearInterval(this.#timer);
    this.#timer = null;
  }

  #go(next, manual = false) {
    const count = this.slides.length;
    this.slides[this.#index].hidden = true;
    this.#index = (next + count) % count;
    this.slides[this.#index].hidden = false;
    if (manual) this.#start();
  }
}

if (!customElements.get('s-announcement-rotator')) {
  customElements.define('s-announcement-rotator', SAnnouncementRotator);
}
